import maplibregl from 'maplibre-gl';

const STYLE = 'https://tiles.openfreemap.org/styles/positron';
const SALON = { lng: 17.342117, lat: 51.256715 };

const MARKER_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.045 12.524" aria-hidden="true">
  <path d="M4.522,0A4.52,4.52,0,0,0,0,4.519c0,1.951,2.972,6.068,4.522,8,1.551-1.937,4.522-6.054,4.522-8A4.52,4.52,0,0,0,4.522,0Zm0,6.742A2.224,2.224,0,1,1,6.748,4.519,2.226,2.226,0,0,1,4.522,6.742Z" fill="#543e3b"/>
</svg>
`.trim();

const Map = () => {
    const container = document.getElementById('map-div');
    if (!container) return;

    const map = new maplibregl.Map({
        container: 'map-div',
        style: STYLE,
        center: [SALON.lng, SALON.lat],
        zoom: 16.5,
    });

    const element = document.createElement('div');
    element.id = 'marker';
    element.innerHTML = MARKER_SVG;

    new maplibregl.Marker({ element, anchor: 'bottom' })
        .setLngLat([SALON.lng, SALON.lat])
        .addTo(map);
};

export default Map;
